<template>
  <div id="app" class="container-fluid">
    <header>
      <login-header v-if="!somiolo" :ambiente="ambiente" />
      <siop-messages></siop-messages>
    </header>
    <main>
      <router-view></router-view>
    </main>
    <footer v-if="!somiolo">
      <login-footer v-if="!somiolo" />
    </footer>
     <webchat v-if="isExibirWebchat() && !somiolo" :ambiente="ambiente" />
  </div>
</template>

<script>
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Webchat from './components/Webchat.vue'
import Messages from './components/Messages.vue'

const queryAmbiente = `query ambiente(){
  ambiente()
}`

export default {
  name: 'app',
  components: {
    'login-header': Header,
    'login-footer': Footer,
    'siop-messages': Messages,
    webchat: Webchat
  },
  data: function () {
    return {
      ambiente: ''
    }
  },
  async created () {
    try {
      const response = await fetch('/modulo/login/api', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ query: queryAmbiente })
      })

      if (response.ok) {
        const data = await response.json()
        if (data && data.data && data.data.ambiente) {
          this.ambiente = data.data.ambiente
          window.localStorage.setItem('ambiente', this.ambiente)
        }
      }
    } catch (error) {
      console.log('Erro ao buscar ambiente:', error)
    }
  },
  computed: {
    somiolo: function () {
      return this.$route.query.somiolo !== undefined
    }
  },
  methods: {
    isExibirWebchat () {
      return this.ambiente.toLowerCase().indexOf('teste') !== -1 || this.ambiente.toLowerCase().indexOf('diário') !== -1 || this.ambiente.toLowerCase().indexOf('produção') !== -1
    }
  }
}
</script>
